// extracted by mini-css-extract-plugin
export default {"languages":"lang_languages__M6PFL","lang":"lang_lang__UqEFs"};